module.exports = __webpack_public_path__ + "static/banner-trackmylifts-white-d4a27b46a40fa0b6887337fb662d3c6c.png";